(function () {

seedWebApp.controller('StageModalCtrl', StageModal);

    function StageModal(item, translation, isEdit, $uibModal, $uibModalInstance, HelpdeskService, ToastService) {
        var ctrl = this;

        ctrl.item = item;
        ctrl.translation = translation;
        ctrl.isEdit = isEdit;
        //ctrl.stages = HelpdeskService.getStages();

        HelpdeskService.getStagesByID().then(
            function (response) {                
                ctrl.stages = response;
            }
        );
        //console.log('ctrl.STAGES ', ctrl.stages);

        console.log('item', item);

        if (!ctrl.item.StageID)
        {
            item.Fields = [];
        }

        ctrl.addStage = function () {
            HelpdeskService.addStage(ctrl.item).then(function (response) {
                successToast('Stage Adicionado.');
                $uibModalInstance.close();
            })
                .catch(function (error) {
                    var errMsg = ToastService.getErrorMsg(error);
                    errorToast('Não Pode Haver ID Duplicado. ' + errMsg);
                });
        }

        ctrl.updateStage = function () {
            HelpdeskService.updateStage(ctrl.item).then(function (response) {
                successToast('Stage Atualizado.');
                $uibModalInstance.close();
            })
                .catch(function (error) {
                    var errMsg = ToastService.getErrorMsg(error);
                    errorToast('Erro ao Atualizar ' + errMsg);
                });
        }

        ctrl.deleteStage = function () {
            modalDeleteResult(openModalDelete());
        }

        ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        ctrl.editEmail = function () {
            $uibModal.open({
                templateUrl: './SPA/Settings/Stages/StageEmailModal.html' + seedWebApp.buildVersion,
                controller: 'StageEmailModalCtrl as ctrl',
                size: 'lg',
                resolve: {
                    item: function () {
                        return ctrl.item;
                    },
                    translation: function () {
                        return ctrl.translation;
                    },
                }
            });

        };

        function openModalDelete() {
            return $uibModal.open({
                templateUrl: './SPA/Shared/delete-modal.html' + seedWebApp.buildVersion,
                controller: 'DeleteModalCtrl as ctrl',
                size: 'md',
                resolve: {                   
                    translation: function () {
                        return ctrl.translation;
                    },
                }
            });
        }

        function modalDeleteResult(modalInstance) {
            modalInstance.result.then(function (response) {
                if (response == 'true') confirmDeleteDoc();
            });
        }

        function confirmDeleteDoc() {
            HelpdeskService.deleteStage(ctrl.item.StageID)
                .then(function (response) {
                    successToast('Stage Removido.');
                    $uibModalInstance.close();
                })
                .catch(function (error) {
                    var errMsg = ToastService.getErrorMsg(error);
                    errorToast('Erro ao Remover ' + errMsg);
            });
        }

        function successToast(msg) {
            ToastService.createToast(ctrl.translation.Success, msg, 8000, 'success');
        }

        function errorToast(error) {
            ToastService.createToast(ctrl.translation.Error, error, 0, 'error');
        }
    }
})();